<template>
  <div class="home-view">
    <Sidebar />
    <div class="content">
      <ChartList class="chart-list-container" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

// Components
import Sidebar from '../components/Sidebar.vue';
import ChartList from '../components/ChartList.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    Sidebar,
    ChartList
  },
});
</script>

<style scoped>
.home-view {
  display: flex;
  height: 100vh;
}

.sidebar {
  width: 250px;
  height: 100vh;
  position: fixed; /* Fix sidebar in place */
  left: 0;
  top: 0;
}

.content {
  margin-left: 250px; /* Ensure ChartList starts after sidebar */
  width: calc(100% - 250px); /* Take remaining space */
  height: 100vh;
  overflow: auto;
  display: flex;
}

.chart-list-container {
  flex: 1;
  padding: 20px;
  background-color: #fff;
}
</style>
